import type { ReactNode } from 'react';
import { Box } from '@mui/material';

const visuallyHiddenSx = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  whiteSpace: 'nowrap',
  width: '1px',
} as const;

/** Text for screen readers only (e.g. „öffnet in neuem Tab“, live status announcements). */
export function VisuallyHidden({
  children,
  live = false,
}: {
  children: ReactNode;
  /** Render as polite live region (§82): changes of the content are announced. */
  live?: boolean;
}) {
  return live ? (
    <Box role="status" aria-live="polite" aria-atomic="true" sx={visuallyHiddenSx}>
      {children}
    </Box>
  ) : (
    <Box component="span" sx={visuallyHiddenSx}>
      {children}
    </Box>
  );
}
